import React from "react";

export default function Pagination({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <section>
      <div className="flex justify-between bg-white rounded-b-xl items-center border-t border-[#EBEBEB] p-4">
        <div>
          <span className="text-sm text-black font-semibold">
            Showing {startItem}-{endItem} of {totalItems}
          </span>
        </div>
        <div>
          <ol className="flex justify-center text-xs font-medium space-x-1">
            {/* Prev Button */}
            <li>
              <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="inline-flex items-center justify-center w-8 h-8 border border-[#EBEBEB] rounded disabled:opacity-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </li>

            {/* Page Numbers */}
            {pages.map((page) => (
              <li key={page}>
                {page === currentPage ? (
                  <span className="block w-8 h-8 text-center text-white bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)] border-blue-600 rounded leading-8">
                    {page}
                  </span>
                ) : (
                  <button
                    onClick={() => onPageChange(page)}
                    className="block w-8 h-8 text-center border border-[#EBEBEB] rounded leading-8"
                  >
                    {page}
                  </button>
                )}
              </li>
            ))}

            {/* Next Button */}
            <li>
              <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="inline-flex items-center justify-center w-8 h-8 border border-[#EBEBEB] rounded disabled:opacity-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
}
